import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';

export const useIsProjectAdmin = () => {
	const { data } = useProjectContext();

	return !!data?.isProjectAdmin;
};
